import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TaskComponent } from './task.component';
import { TaskFormComponent } from './task-form/task-form.component';
import {FormsModule} from "@angular/forms";



@NgModule({
    declarations: [TaskComponent, TaskFormComponent],
    exports: [
        TaskComponent,
        TaskFormComponent
    ],
    imports: [
        CommonModule,
        FormsModule
    ]
})
export class TaskModule { }
